import React, { } from 'react'
import { useTranslation } from 'react-i18next'
import { CounterTitle, HorizontalFormWrapper } from '../dashboard.styled'
import { DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Input, InputNumber, Select } from 'antd'

function PIISetting (props) {
  const { defPlaceholder, piiSchema, counter, handleDelCounter, handleAddCounter } = props
  const { t: ln_t } = useTranslation()

  return (
    <>
      {counter?.map(key => (
        <React.Fragment key={key}>
          <CounterTitle>
            {ln_t('dashboard.pii')} #{key}
            {counter.length > 1 ? <DeleteTwoTone style={{ cursor: 'pointer' }} twoToneColor="#707070" onClick={() => handleDelCounter(key)} /> : ''}
          </CounterTitle>
          <HorizontalFormWrapper>
            <Form.Item name={`${key}-column`} rules={[{ required: true, message: defPlaceholder('column', 'select') }]}>
              <Select showSearch placeholder={defPlaceholder('column', 'select')} options={piiSchema} optionFilterProp="children" />
            </Form.Item>
            <Form.Item name={`${key}-rename`} rules={[{ required: false, message: defPlaceholder('rename', 'input') }]}>
              <Input placeholder={defPlaceholder('rename', 'input')} />
            </Form.Item>
            <Form.Item name={`${key}-sort`} rules={[{ required: true, message: defPlaceholder('sort', 'input') }]}>
              <InputNumber placeholder={defPlaceholder('sort', 'input')} precision={0} style={{ width: '100%' }} />
            </Form.Item>
          </HorizontalFormWrapper>
        </React.Fragment>
      ))}
      <Button type="default" style={{ width: '100%', marginTop: '8px' }} icon={<PlusOutlined />} onClick={handleAddCounter}>
        {ln_t('util.add')} {ln_t('dashboard.pii')}
      </Button>
    </>
  )
}

export default PIISetting
